import { Empty, Skeleton, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import { AddNotiModalList } from 'features/notification/components/modal/AddModalList';
import { SendNotificationModal } from 'features/notification/components/modal/send-notification-modal';
import { NotificationFilterFormValuesPaginated } from 'features/notification/components/type';
import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationTemplate } from 'types/notification-list';

type NotificationTableProps = {
  isUsersListLoading: boolean;
  List?: any;
  itemsCount: number;
  tableParams: NotificationFilterFormValuesPaginated;
  refetch: any;
  EditData: any;
  setEditData: any;
  updateParams: Dispatch<SetStateAction<NotificationFilterFormValuesPaginated>>;
};

export const NotificationListTable = ({
  List,
  isUsersListLoading,
  itemsCount,
  refetch,
  EditData,
  setEditData,
  tableParams,
  updateParams,
}: NotificationTableProps) => {
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);
  const [showSendNoti, setShowSendNoti] = useState<boolean>(false);
  const [sendNotiData, setSendNotiData] = useState<any>(null);

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData(undefined);
  };

  //  Unused (kept as comment to avoid ESLint error)
  /*
  const handleOpenModal = (record: any) => {
   
    setShowModal(true);
    setEditData(record);

  }
    setShowModal(true);
    setEditData(record);
  };
  */

  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<NotificationTemplate> | SorterResult<NotificationTemplate>[],
  ) => {
    updateParams({
      ...tableParams,
      page: pagination.current,
      size: pagination.pageSize,
      order_by: Array.isArray(sorter)
        ? undefined
        : sorter.order === 'ascend'
          ? 'Title'
          : '-Title',
    });
  };

  const handleCloseSendNoti = () => {
    setShowSendNoti(false);
    setSendNotiData(null);
  };

  //  Unused (kept as comment to avoid ESLint error)
  /*
  const handleOpenSendNoti = (record: any) => {
    setShowSendNoti(true);
    setSendNotiData(record);
  };
  */


  // console.log("Table DataSource:", isUsersListLoading ? [] : List || []);

  return (
    <StyledTableWrapper>
      <div className={`cstmrightmdl ${showModal && 'show'}`}>
        <AddNotiModalList
          showModal={showModal}
          refetch={refetch}
          onClose={handleCloseModal}
          EditData={EditData}
        />
      </div>

      <div className={`cstmrightmdl ${showSendNoti && 'show'}`}>
        <SendNotificationModal
          showModal={showSendNoti}
          refetch={refetch}
          onClose={handleCloseSendNoti}
          EditData={sendNotiData}
        />
      </div>

      <StyledTableHeader>
        <RecordCountBadge
          text={t('vendingMachine.foundRecord')}
          count={isUsersListLoading ? 0 : itemsCount || 0}
        />
      </StyledTableHeader>

      <Table<NotificationTemplate>
        className="cstltblwthldr"
        locale={{
          emptyText: isUsersListLoading ? <Skeleton active /> : <Empty />,
        }}
        loading={
          isUsersListLoading && { indicator: <div><TableLoader /></div> }
        }
        dataSource={isUsersListLoading ? [] : List || []}
        rowKey="Id"
        onChange={handleTableChange}
        pagination={{
          current: tableParams.page,
          defaultPageSize: tableParams.size,
          total: itemsCount,
        }}
      >
        <Column<NotificationTemplate>
          title="Title"
          dataIndex="Title"
        />

        <Column<NotificationTemplate>
          title="Type"
          dataIndex="AnnouncementType"
        />

        <Column<NotificationTemplate>
          title="Content"
          dataIndex="ContentEn"
        />
      </Table>
    </StyledTableWrapper>
  );
};